(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cons-inf-user', {
            parent: 'entity',
            url: '/cons-inf-user',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-users.html',
                    controller: 'ConsInfUserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cons-inf-user-detail', {
            parent: 'cons-inf-user',
            url: '/cons-inf-user/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfUser.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-detail.html',
                    controller: 'ConsInfUserDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfUser');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ConsInfUser', function($stateParams, ConsInfUser) {
                    return ConsInfUser.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cons-inf-user',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cons-inf-user-detail.edit', {
            parent: 'cons-inf-user-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-dialog.html',
                    controller: 'ConsInfUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfUser', function(ConsInfUser) {
                            return ConsInfUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-user.new', {
            parent: 'cons-inf-user',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-dialog.html',
                    controller: 'ConsInfUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                active: null,
                                longName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cons-inf-user', null, { reload: 'cons-inf-user' });
                }, function() {
                    $state.go('cons-inf-user');
                });
            }]
        })
        .state('cons-inf-user.edit', {
            parent: 'cons-inf-user',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-dialog.html',
                    controller: 'ConsInfUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfUser', function(ConsInfUser) {
                            return ConsInfUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-user', null, { reload: 'cons-inf-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-user.delete', {
            parent: 'cons-inf-user',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-user/cons-inf-user-delete-dialog.html',
                    controller: 'ConsInfUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ConsInfUser', function(ConsInfUser) {
                            return ConsInfUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-user', null, { reload: 'cons-inf-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
